/** Today's date in the user's time zone as YYYY-MM-DD (the value of an `<input type="date">`). */
export function localToday(now: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/**
 * Translation key of the problem with a date of death, or null when it is valid:
 * required, never before the date the animal was added, never in the future.
 * Mirrors the API rule (src/services/livestockDeceased.ts).
 */
export function deceasedDateError(value: string, dateAdded: string, today: string = localToday()): string | null {
  if (!value) return 'livestock.deceased.validation.required';
  if (dateAdded && value < dateAdded) return 'livestock.deceased.validation.beforeAdded';
  if (value > today) return 'livestock.deceased.validation.future';
  return null;
}

/** "Verstorben am 20.09.2026" — the date formatted for the UI language. */
export function formatDeceasedDate(value: string, language: string): string {
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return value;
  try {
    return new Date(y, m - 1, d).toLocaleDateString(language || undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return value;
  }
}
